<div class="container mt-3">
  <h5 class="text-white">Fleet Experience</h5>
  <p class="text-white">Please enter most recent policy period in year 1 with the next years in year 2 and year 3. A maximum of 5 claims years can be added.</p>

  <div *ngFor="let fleet of fleetYears; let fi = index" class="card mb-3 p-3">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h6>Year {{fi + 1}}</h6>
      <button class="btn btn-danger btn-sm" (click)="removeYear(fi)" *ngIf="fleetYears.length > 1">Remove</button>
    </div>

    <div class="row mb-2">
      <div class="col-md-3">
        <label>Start Date <span class="text-danger">*</span></label>
        <input type="date" class="form-control" [(ngModel)]="fleet.start_date" (change)="calculateEndDate(fleet)"
          [ngClass]="{ 'is-invalid': submitted && isFieldMissing(fleet, 'start_date') }">
        <div class="invalid-feedback d-block" *ngIf="submitted && isFieldMissing(fleet, 'start_date')">Start date is required.</div>
      </div>
      <div class="col-md-3">
        <label>End Date</label>
        <input type="date" class="form-control" [(ngModel)]="fleet.end_date" readonly>
      </div>
      <div class="col-md-3">
        <label>Vehicle Years <span class="text-danger">*</span></label>
        <input type="number" class="form-control" [(ngModel)]="fleet.years" min="0" step="1"
          (change)="clampToZero(fleet, 'years')"
          [ngClass]="{ 'is-invalid': submitted && (isFieldMissing(fleet, 'years') || isFieldNegative(fleet, 'years')) }">
        <small class="text-muted">Sum of all vehicles insured in this period.</small>
        <div class="invalid-feedback d-block" *ngIf="submitted && isFieldMissing(fleet, 'years')">Vehicle years is required.</div>
        <div class="invalid-feedback d-block" *ngIf="isFieldNegative(fleet, 'years')">Vehicle years cannot be negative.</div>
      </div>
      <div class="col-md-3">
        <label>Number of Reported Claims <span class="text-danger">*</span></label>
        <input type="number" class="form-control" [(ngModel)]="fleet.claims" min="0" step="1"
          (change)="clampToZero(fleet, 'claims')"
          [ngClass]="{ 'is-invalid': submitted && (isFieldMissing(fleet, 'claims') || isFieldNegative(fleet, 'claims')) }">
        <div class="invalid-feedback d-block" *ngIf="submitted && isFieldMissing(fleet, 'claims')">Number of reported claims is required.</div>
        <div class="invalid-feedback d-block" *ngIf="isFieldNegative(fleet, 'claims')">Number of reported claims cannot be negative.</div>
      </div>
    </div>

    <div *ngIf="fleet.claims > 0">
      <h6 class="mt-3">Claims Breakdown <span class="text-danger">*</span></h6>
      <div class="invalid-feedback d-block mb-2" *ngIf="submitted && isBreakdownMissing(fleet)">
        Please enter the paid and/or outstanding amounts for the {{fleet.claims}} claim(s) reported in year {{fi + 1}}.
      </div>
      <table class="table table-bordered table-sm"
        [ngClass]="{ 'border border-danger': submitted && isBreakdownMissing(fleet) }">
        <thead>
          <tr>
            <th></th>
            <th>Own Damage (£)</th>
            <th>Fire & Theft (£)</th>
            <th>Third Party (£)</th>
            <th>Total (£)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>Paid</strong></td>
            <td><input type="number" class="form-control form-control-sm" [(ngModel)]="fleet.paid.own_damage"></td>
            <td><input type="number" class="form-control form-control-sm" [(ngModel)]="fleet.paid.fire_theft"></td>
            <td><input type="number" class="form-control form-control-sm" [(ngModel)]="fleet.paid.third_party"></td>
            <td>{{getPaidTotal(fleet) | number:'1.2-2'}}</td>
          </tr>
          <tr>
            <td><strong>Outstanding</strong></td>
            <td><input type="number" class="form-control form-control-sm" [(ngModel)]="fleet.outstanding.own_damage"></td>
            <td><input type="number" class="form-control form-control-sm" [(ngModel)]="fleet.outstanding.fire_theft"></td>
            <td><input type="number" class="form-control form-control-sm" [(ngModel)]="fleet.outstanding.third_party"></td>
            <td>{{getOutstandingTotal(fleet) | number:'1.2-2'}}</td>
          </tr>
          <tr>
            <td><strong>Total</strong></td>
            <td>{{(fleet.paid.own_damage || 0) + (fleet.outstanding.own_damage || 0) | number:'1.2-2'}}</td>
            <td>{{(fleet.paid.fire_theft || 0) + (fleet.outstanding.fire_theft || 0) | number:'1.2-2'}}</td>
            <td>{{(fleet.paid.third_party || 0) + (fleet.outstanding.third_party || 0) | number:'1.2-2'}}</td>
            <td><strong>{{getGrandTotal(fleet) | number:'1.2-2'}}</strong></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="row mb-2">
      <div class="col-md-12">
        <label>Please provide details of any individual large or unusual loss in year {{fi + 1}}</label>
        <textarea class="form-control" [(ngModel)]="fleet.details" rows="2"></textarea>
      </div>
    </div>
  </div>

  <button class="btn btn-outline-light btn-sm mb-3" style="color: white; border-color: white;" (click)="addYear()" *ngIf="fleetYears.length < 5">Add Another Year</button>

  <div class="row mt-4 mb-3">
    <div class="col-md-6">
      <button class="btn btn-secondary btn-sm" (click)="prevTab()">Previous</button>
    </div>
    <div class="col-md-6 text-right">
      <button class="btn btn-success btn-sm" (click)="nextTab()">Proceed</button>
    </div>
  </div>
</div>
